import type { PdpNavigationSteps } from "../utils/navigationSteps";
import "./PdpNavigationSteps.css";

type PdpNavigationStepsProps = {
  navigationSteps?: PdpNavigationSteps;
};

export function PdpNavigationSteps({
  navigationSteps,
}: PdpNavigationStepsProps) {
  if (!navigationSteps?.length) {
    return null;
  }

  const currentStepIndex = navigationSteps.findIndex(
    (step) => step.isCurrentPage,
  );
  const breadcrumbSubtitle = navigationSteps.find((step) =>
    step.breadcrumbSubtitle?.trim(),
  )?.breadcrumbSubtitle;

  return (
    <nav className="react-pdp__navigation" aria-label="Produktablauf">
      <ol className="react-pdp__navigation-list">
        {navigationSteps.map((step, index) => {
          const isCurrentOrPast =
            currentStepIndex >= 0 && index <= currentStepIndex;
          const content = (
            <>
              <span
                className={`react-pdp__navigation-marker${
                  isCurrentOrPast
                    ? " react-pdp__navigation-marker--checked"
                    : ""
                }`}
                aria-hidden="true"
              >
                {isCurrentOrPast ? (
                  <span className="material-symbols-rounded">check</span>
                ) : null}
              </span>
              <span className="react-pdp__navigation-label">
                {step.breadcrumbTitle}
              </span>
            </>
          );

          return (
            <>
              <li className="react-pdp__navigation-item" key={step.id}>
                {step.isCurrentPage ? (
                  <span
                    className="react-pdp__navigation-step react-pdp__navigation-step--current"
                    aria-current="step"
                  >
                    {content}
                  </span>
                ) : (
                  <a className="react-pdp__navigation-step" href={step.href}>
                    {content}
                  </a>
                )}
              </li>
              {index < navigationSteps.length - 1 ? (
                <li className="react-pdp__navigation-connector" />
              ) : null}
            </>
          );
        })}
      </ol>
      {breadcrumbSubtitle ? (
        <p className="react-pdp__navigation-subtitle">{breadcrumbSubtitle}</p>
      ) : null}
    </nav>
  );
}
